import { useTranslation } from 'libs/i18n';
import {
  CompanyTaxResidencySection as CompanyTaxResidencySectionBase,
  CompanyTaxResidencySectionProps,
} from 'modules/client/common/components/sections/CompanyTaxResidencySection';

interface Props extends Omit<CompanyTaxResidencySectionProps, 'title'> {}

export const CompanyTaxResidencySection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();
  return (
    <CompanyTaxResidencySectionBase
      title={t('client.client.taxResidency.title')}
      {...formProps}
    />
  );
};
